import {axios} from '@/api/axios';
import {AxiosResponse} from 'axios';
import {EventType} from '@/types/event-type';
import {EVENT_URLS} from '@/api/urls';
import {formatString} from '@/utils';
import {EventStatistic} from '@/types/event-statistic';

export const EventApi = {
  getList: () => axios.get<EventType[]>(EVENT_URLS.GET_LIST),
  getEvent: (eventId: string) => axios.get<EventType>(formatString(EVENT_URLS.GET_EVENT, eventId)),
  getEventResource: (eventId: string, resource: string) => axios.get<EventType[]>(formatString(EVENT_URLS.GET_RESOURCE, eventId, resource)),
  getStatistic: (token: string) => axios.get<EventStatistic>(formatString(EVENT_URLS.GET_STATISTIC, token)),

  save: (data: any) => axios.post<EventType>(EVENT_URLS.SAVE, data),
  edit: (eventId: string, data: EventType) => axios.put<AxiosResponse<EventType>>(formatString(EVENT_URLS.EDIT, eventId), data),
  delete: (eventId: string) => axios.delete(formatString(EVENT_URLS.DELETE, eventId))
};
